/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Mb } from './Mb';

const { GlobalVar } = Utils;

class MemberLevel extends Mb {
    constructor() {
        super();
        this.baseUrl += '/memberLevel';
    }

    data({ levelName, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            levelName,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { levelIcon } = json.data.data;
            if (!levelIcon) {
                json.data.data.levelIcon = [];
            } else {
                json.data.data.levelIcon = levelIcon.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({
        id,
        levelName,
        levelDesc,
        levelIcon,
        orderNum,
        isAvailable,
        isDefault,
        isGainGrowthValue,
        isGrowthValueUpgrade,
        gradeGrowthValue,
    } = {}) {
        const levelIconStr = levelIcon
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            levelName,
            levelDesc,
            levelIcon: levelIconStr,
            orderNum,
            isAvailable,
            isDefault,
            isGainGrowthValue,
            isGrowthValueUpgrade,
            gradeGrowthValue,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable }) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    isDefault({ id, isDefault }) {
        return super.post('/isDefault', {
            id,
            isDefault,
        });
    }

    select() {
        return super.get('/select', {});
    }
}

export default new MemberLevel();
export { MemberLevel };
